import { type Href, useNavigation, useRouter } from 'expo-router';

// this is used to exit a modal (like persona-import or persona-archive)
// and redirect to the next route
// this doesn't feel like the right way to solve this problem tho...
// the issue with `route.dismissAll()` is that you can't call `.push` after without hacks
// this solution is inspired from https://github.com/expo/expo/issues/26922#issuecomment-2115767085
export function useRollbackAndReplace() {
  const navigation = useNavigation();
  const router = useRouter();

  const rollbackAndReplace = async (href: Href) => {
    const state = navigation.getState();

    if (!state) {
      // failsafe
      router.dismissAll();
      return;
    }

    let indexIdx = state.routeNames.indexOf('index');

    // failsafe (2)
    if (indexIdx === -1) {
      indexIdx = 0;
    }

    // go back from state.routeNames.length to the index route (or just first route if no index route)
    for (let i = state.routeNames.length - 1; i > indexIdx; i--) {
      if (router.canGoBack()) {
        router.back();
      }
    }

    router.replace(href);
  };

  return rollbackAndReplace;
}
